import React from 'react';
import { useSelector } from 'react-redux';
import { BlockOutlined } from '@mui/icons-material';
import loadingSpinner from 'common/assets/images/loading-spinner.gif';

export function ShowLoader() {
  const isLoadingMyPerfTrainingStatusData = useSelector(
    (state) => state.trainingMetricsRd?.isLoadingMyPerfTrainingStatusData,
  );
  const isLoadingPopupListingDataMyDirectReportee = useSelector(
    (state) => state.tapDirectReporteePopUpDetailsRd?.isLoadingPopupListingDataMyDirectReportee,
  );
  const isLoadingPopupListingDataForMyOrg = useSelector(
    (state) => state.tapPopUpDetailsRd?.isLoadingPopupListingDataForMyOrg,
  );
  const isLoadingpPopupListingData = useSelector(
    (state) => state?.tapAdminPopUpDetailsRd?.isLoadingPopupListingData,
  );
  const isLoadingCompletedOnTimeData = useSelector(
    (state) => state.trainingMetricsRd?.isLoadingCompletedOnTimeData,
  );
  const isLoadingCompletedOverallData = useSelector(
    (state) => state.trainingMetricsRd?.isLoadingCompletedOverallData,
  );
  const isLoadingMyOrgCompletionData = useSelector(
    (state) => state.myOrgTrainingCompletionRd?.isLoadingMyOrgCompletionData,
  );
  const isLoadingMyDirectCompletionData = useSelector(
    (state) => state.myDirectTrainingCompletionRd?.isLoadingMyDirectCompletionData,
  );
  const isLoadingMyDirectComplianceData = useSelector(
    (state) => state.MyDirectReporteeComplianceProfileRd?.isLoadingMyDirectComplianceData,
  );
  const isLoadingNonCompliantData = useSelector(
    (state) => state?.myOrgComplianceActionsRd?.isLoadingNonCompliantData,
  );
  const isLoadingAtRiskData = useSelector(
    (state) => state?.myOrgComplianceActionsRd?.isLoadingAtRiskData,
  );
  const isLoadingDRNonCompliantData = useSelector(
    (state) => state?.directReporteeComplianceActionsRd?.isLoadingDRNonCompliantData,
  );
  const isLoadingDRAtRiskData = useSelector(
    (state) => state?.directReporteeComplianceActionsRd?.isLoadingDRAtRiskData,
  );
  const isLoadingTrainingOverDueData = useSelector(
    (state) => state?.teamPerformanceRd?.isLoadingTrainingOverDueData,
  );
  const isLoadingTrainingUpcomingDueData = useSelector(
    (state) => state?.teamPerformanceRd?.isLoadingTrainingUpcomingDueData,
  );
  const isLoadingDRTrainingOverDueData = useSelector(
    (state) => state?.teamPerformanceDirectRd?.isLoadingDRTrainingOverDueData,
  );
  const isLoadingDRTrainingUpcomingDueData = useSelector(
    (state) => state?.teamPerformanceDirectRd?.isLoadingDRTrainingUpcomingDueData,
  );
  let isFilteringMyOrgTrainingsData = useSelector(
    (state) => state.filterMyOrgTrainingsRd?.isFilteringMyOrgTrainingsData,
  );
  let isFetchingTVIndividualUserData = useSelector(
    (state) => state.trainingViewIndividualUserRd?.isFetchingTVIndividualUserData,
  );
  let isFetchingTVManagerDRData = useSelector(
    (state) => state.tapTrainingPlanViewDirectReporteeMrgSnglTeamRd?.isFetchingTVManagerDRData,
  );
  const isFetchingAVComplianceStatus = useSelector(
    (state) => state.adminComplianceProfileRd?.isFetchingAVComplianceStatus,
  );
  const isLoadingAdminNonCompliantData = useSelector(
    (state) => state?.adminComplianceActionsRd?.isLoadingAdminNonCompliantData,
  );
  const isLoadingAdminAtRiskData = useSelector(
    (state) => state?.adminComplianceActionsRd?.isLoadingAdminAtRiskData,
  );
  const isLoadingADTrainingOverDueData = useSelector(
    (state) => state?.adminRd?.isLoadingADTrainingOverDueData,
  );
  const isLoadingADTrainingUpcomingDueData = useSelector(
    (state) => state?.adminRd?.isLoadingADTrainingUpcomingDueData,
  );
  const isFetchingMyTeamsPerformanceReportDownload = useSelector(
    (state) =>
      state?.teamsPerformanceLargeDownloadReducer?.isFetchingMyTeamsPerformanceReportDownload,
  );
  const isFetchingMyTeamsPerformanceLargeReportDownload = useSelector(
    (state) =>
      state?.teamsPerformanceDownloadReducer?.isFetchingMyTeamsPerformanceLargeReportDownload,
  );
  const isLoadingPeopleLeaderAlerts = useSelector(
    (state) => state.alertRd?.isLoadingPeopleLeaderAlerts,
  );
  const isLoadingAdminAlerts = useSelector(
    (state) => state.alertRd?.isLoadingAdminAlerts,
  );
  const isLoadingAdminMuteAlerts = useSelector(
    (state) => state.alertRd?.isLoadingAdminMuteAlerts,
  );
  const isLoadingMutePeopleLeaderAlerts = useSelector(
  (state) => state.alertRd?.isLoadingMutePeopleLeaderAlerts,
  );
  const isLoadingDeleteAlerts = useSelector(
  (state) => state.alertRd?.isLoadingDeleteAlerts,
  );
  const isLoadingDeleteAdminAlerts = useSelector(
    (state) => state.alertRd?.isLoadingDeleteAdminAlerts,
  );
  const isLoadingMyTeamProfileFilterData = useSelector(
    (state) => state.myTeamProfileRd?.isLoadingMyTeamProfileFilterData,
  );
  const isLoadingSavedDelegate = useSelector(
    (state) => state?.delegateUserRd?.isLoadingSavedDelegate
  );
  const isLoadingViewDelegate = useSelector(
    (state) => state?.delegateUserRd?.isLoadingViewDelegate
  );
  const isLoadingDelegateDelete = useSelector(
    (state) => state?.delegateUserRd?.isLoadingDelegateDelete
  );
  

  return (
    <div>
      {isLoadingMyPerfTrainingStatusData ||
      isLoadingCompletedOnTimeData ||
      isLoadingCompletedOverallData ||
      isLoadingMyOrgCompletionData ||
      isLoadingMyDirectCompletionData ||
      isLoadingMyDirectComplianceData ||
      isLoadingDRNonCompliantData ||
      isLoadingDRAtRiskData ||
      isLoadingNonCompliantData ||
      isLoadingAtRiskData ||
      isLoadingTrainingOverDueData ||
      isLoadingTrainingUpcomingDueData ||
      isLoadingDRTrainingOverDueData ||
      isLoadingDRTrainingUpcomingDueData ||
      isFilteringMyOrgTrainingsData ||
      isFetchingTVIndividualUserData ||
      isFetchingTVManagerDRData ||
      isFetchingAVComplianceStatus ||
      isLoadingAdminNonCompliantData ||
      isLoadingADTrainingOverDueData ||
      isLoadingADTrainingUpcomingDueData ||
      isLoadingAdminAtRiskData ||
      isLoadingPeopleLeaderAlerts ||
      isLoadingAdminAlerts ||
      isLoadingAdminMuteAlerts ||
      isLoadingMutePeopleLeaderAlerts ||
      isLoadingDeleteAdminAlerts ||
      isLoadingDeleteAlerts ||
      isFetchingMyTeamsPerformanceReportDownload ||
      isLoadingpPopupListingData ||
      isLoadingPopupListingDataForMyOrg ||
      isLoadingPopupListingDataMyDirectReportee ||
      isLoadingMyTeamProfileFilterData ||
      isFetchingMyTeamsPerformanceLargeReportDownload ||
      isLoadingSavedDelegate || isLoadingViewDelegate || 
      isLoadingDelegateDelete ? (
        <div
          className='loading-spinner'
          style={{
            position: 'fixed',
            top: '0px',
            left: '0px',
            height: '100vh',
            width: '98.9vw',
            zIndex: 99999,
            backgroundColor: 'rgb(0 0 0 / 60%)',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <img
            style={{
              height: '80px',
              margin: 'auto',
              display: BlockOutlined,
            }}
            src={loadingSpinner}
            alt='Loading...'
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
